module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-9.7f46cdd2.jpg";